import React, { useState } from 'react';
import Sidebar from 'components/Sidebar';
import MobileHeader from 'components/MobileHeader';
import SearchOverlay from 'components/SearchOverlay';
import Container from 'components/Container';
import { Link, useParams } from 'react-router-dom';
import { CaretLeftIcon } from '@phosphor-icons/react';
import { useQuery } from '@tanstack/react-query';
import { getModel } from 'api/models';
import LoadingOverlay from 'components/LoadingOverlay';
import ModelEditPopup from 'components/ModelEditPopup';
import Button from 'components/Button';

export default function Model() {

    const [sidebar, setSidebar] = useState(false);
    const [search, setSearch] = useState(false);
    const [editModelPopup, setEditModelPopup] = useState(false);
    const { modelId } = useParams();

    const { data: model, isLoading } = useQuery({
        queryKey: ['models', modelId],
        queryFn: async () => await getModel({ id: modelId }),
    });

    return (
        <>
            <Sidebar
                visible={sidebar}
                setVisible={setSidebar}
            />

            <SearchOverlay
                visible={search}
                setVisible={setSearch}
            />

            <MobileHeader
                sidebar={sidebar}
                setSidebar={setSidebar}
                search={search}
                setSearch={setSearch}
            />

            <LoadingOverlay isLoading={isLoading} />

            <div className={`fixed top-0 w-full bottom-0 transition-all duration-300 ease-in-out lg:pl-[320px] ${sidebar ? 'left-[80vw]' : 'left-0'}`}>
                <Container className='pb-20'>
                    <div className='pb-8 pt-20 md:pt-14 flex gap-3 items-center'>
                        <div className='flex-1 flex gap-3 items-center'>
                            <Link to="/settings/models" className=''>
                                <CaretLeftIcon size={26} className='hover:text-muted' />
                            </Link>
                            <p className='text-3xl'>Dettaglio modello</p>
                        </div>
                        <Button onClick={() => setEditModelPopup(true)}>Modifica</Button>
                    </div>

                    <div className='flex gap-10'>
                        <div className='flex-1 border border-light rounded-sm'>
                            <div className='p-4'>
                                <p className='text-lg font-semibold pb-2'>
                                    {model?.name}
                                    {model?.enabled ? (
                                        <span className='text-xs text-lime-500 font-medium uppercase ml-2'>Attivo</span>
                                    ) : (
                                        <span className='text-xs text-red-500 font-medium uppercase ml-2'>Disattivato</span>
                                    )}
                                </p>

                                <div className='space-y-3 mt-4'>
                                    <div>
                                        <p className='text-xs text-muted uppercase'>Modello</p>
                                        <p>{model?.model}</p>
                                    </div>
                                    <div>
                                        <p className='text-xs text-muted uppercase'>Tipo</p>
                                        <p className={`font-medium ${model?.type === 'embedding' ? 'text-purple-500' : 'text-blue-500'}`}>
                                            {model?.type === 'embedding' ? 'Embedding' : 'Model'}
                                        </p>
                                    </div>
                                    <div>
                                        <p className='text-xs text-muted uppercase'>Base URL</p>
                                        <p>{model?.baseUrl || '-'}</p>
                                    </div>
                                    <div>
                                        <p className='text-xs text-muted uppercase'>API Key</p>
                                        <p>{model?.apiKey ? '••••••••••••' : '-'}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Container>
            </div>

            <ModelEditPopup
                visible={editModelPopup}
                setVisible={setEditModelPopup}
                model={model}
            />
        </>
    )
}
